"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayError = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const client_1 = require("@apollo/client");
const styles_1 = require("../styles");
const DisplayError = ({ error }) => {
    if (!error || !error.message)
        return null;
    if (error instanceof client_1.ApolloError) {
        // Handle GraphQL errors
        const graphqlErrors = error.graphQLErrors;
        const networkError = error.networkError;
        console.log('GraphQL errors::', graphqlErrors);
        if (graphqlErrors) {
            return ((0, jsx_runtime_1.jsx)(ErrorStyled, { children: graphqlErrors.map((item, idx) => ((0, jsx_runtime_1.jsx)("p", { children: item.message }, `gql-error-${idx}`))) }));
        }
        if (networkError) {
            // Handle network errors
            console.log('Network error:', networkError);
        }
    }
    else {
        // Handle other non-GraphQL errors here
        console.log('non-GraphQL error or Apollo response error', error);
        return ((0, jsx_runtime_1.jsx)(ErrorStyled, { children: (0, jsx_runtime_1.jsx)("p", { children: typeof error === 'string' ? error : error.message }) }));
    }
};
exports.DisplayError = DisplayError;
const ErrorStyled = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.colors.input_error};
  background: #ff000022;
  margin: 1rem 0;
  padding: .75rem 1rem;
  width: 100%;

  p {
    ${styles_1.getP14Search}
    color: ${({ theme }) => theme.colors.input_error};
    margin: 0;
    font-weight: 100;
  }

  strong {
    margin-right: 1rem;
  }
`;
